import pdfMake, { userMark, setMyConfig, makeTableContent } from '../utils/pdf';
import {
  getColumnsPerService,
  PRINT_COLUMNS,
} from '../modules/biblia/helpers/getColumnsPerService';

function pdfOrdenRegistros(pContent) {
  const idServicio = pContent.orden.idServicio;

  let columnsPerService = getColumnsPerService(idServicio);
  columnsPerService = columnsPerService.filter(
    (item) => !(item == 'estado' || item == 'recomendacionesGuia')
  );

  const columns = [];

  columnsPerService.forEach((column) => {
    columns.push(PRINT_COLUMNS[column]);
  });

  const table = makeTableContent([...pContent.registros], columns);

  const columnsRecomendaciones = [
    {
      key: 'codigo',
      label: 'Código',
      width: 28,
    },
    {
      key: 'recomendacionesGuia',
      label: '',
      width: '*',
    },
  ];

  const partRecomendaciones = pContent.resumen.recomendaciones.length
    ? [
        {
          text: 'Recomendaciones',
          style: 'header',
        },
        makeTableContent([...pContent.resumen.recomendaciones], columnsRecomendaciones),
        {
          text: '',
          margin: [0, 0, 0, 5],
        },
      ]
    : [];

  pdfMake
    .createPdf({
      info: {
        title: `Orden de Servicio: Detalle`,
      },
      content: [
        {
          text: '',
          margin: [0, 0, 0, 10],
        },
        {
          text: 'Orden de Servicio: Detalle',
          style: 'h1',
        },
        {
          columns: [
            {
              text: `Código: ${pContent.orden.codigo || ''}`,
              width: 'auto',
            },
            {
              text: `Servicio: ${pContent.orden.servicio || ''}`,
              width: 'auto',
            },
            {
              text: `Fecha: ${pContent.orden.fecha || ''}`,
              width: 'auto',
            },
            {
              text: `Hora Salida: ${pContent.orden.horaSalida || ''}`,
              width: 'auto',
            },
            {
              text: `Guía: ${pContent.orden?.guia || ''}`,
              width: 'auto',
            },
            {
              text: `Transfer: ${pContent.orden.transfer || ''}`,
              width: 'auto',
            },
            {
              text: `Asistente: ${pContent.orden.asistente || ''}`,
              width: 'auto',
            },
            {
              text: `Móvil: ${pContent.orden.vehiculo || ''}`,
              width: 'auto',
            },
            {
              text: `Conductor: ${pContent.orden.conductor || ''}`,
              width: 'auto',
            },
            {
              text: `Contacto: ${pContent.orden.contactoConductor || ''}`,
              width: 'auto',
            },
            // {
            //   text: `Awanacancha: ${pContent.orden.awanacancha ? "Sí" : "No"}`,
            //   width: "auto",
            // },
          ],
          margin: [0, 0, 0, 2.5],
        },
        {
          columns: [
            {
              text: `Observación: ${pContent.orden.observacion || ''}`,
              width: '*',
            },
          ],
          margin: [0, 0, 0, 2.5],
        },
        table,
        ...partRecomendaciones,
        ...userMark(pContent.userMark, pContent.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}

export default pdfOrdenRegistros;
